<template>
  <section class="content-padding">
    <div class="row mt-3">
      <div class="col-md-12 text-center">
        <h2>{{ $t('message.my_cleaner.title') }}</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 offset-md-2 p-0">
        <nav class="nav nav-tabs nav-justified">
          <a class="nav-item nav-link pointer-item"
             :class="[(currentTab === 'previous') ? 'active' : '']"
             @click.prevent="loadFirstPage('previous')">
            {{ $t('message.my_cleaner.tab_previous') }}
          </a>
          <a class="nav-item nav-link pointer-item"
             :class="[(currentTab === 'saved') ? 'active' : '']"
             @click.prevent="loadFirstPage('saved')">
            {{ $t('message.my_cleaner.tab_saved') }}
          </a>
          <a class="nav-item nav-link pointer-item"
             :class="[(currentTab === 'blacklist') ? 'active' : '']"
             @click.prevent="loadFirstPage('blacklist')">
            {{ $t('message.my_cleaner.tab_blacklist') }}
          </a>
        </nav>
      </div>
    </div>
    <section v-if="professionals">
      <div class="row mt-4" v-if="professionals.length === 0">
        <div class="col-12 text-center">
          <div class="py-4">
            <img src="/static/img/ic-cleaner.svg" width="100" alt="">
          </div>
          <div v-if="currentTab === 'previous'">
            <div>
              {{ $t('message.professional.not_available_previous_cleaner01') }}<br>
              {{ $t('message.professional.not_available_previous_cleaner02') }}
            </div>
            <div class="mt-3">
              <router-link to="/booking/start" tag="button" class="button-large -cyan">
                {{ $t('message.hero.find_new_cleaner') }}
              </router-link>
            </div>
          </div>
          <div v-else>
            {{ $t('message.professional.no_service_provider') }}
          </div>
        </div>
      </div>
      <div class="row mt-4" v-else>
        <div class="col-md-4 col-sm-6 pb-3" v-for="(professional, index) in professionals">
          <a :href="`/cleaner/${professional.id}`"
             class="no-style"
             @click.prevent="openProfessionalDetail(professional)">
            <div class="card m-0 h-100">
              <div class="card-body p-3">
                <div class="d-flex justify-content-start align-items-start">
                  <div>
                    <professional-picture :professional="professional"
                                          :imgClass="'img-fluid'"
                                          :imgSize="60"/>
                  </div>
                  <div class="flex-grow-1 pl-3">
                    <h3 class="mb-1">{{ professional.name | firstName }}</h3>
                    <div class="professional-city">

                    </div>
                    <div class="mt-1 text-remark">
                      <span v-if="professional.rating && professional.rating > 0">
                        <i class="fas fa-star -rating-star"></i> {{ professional.rating.toFixed(1) }} ({{ professional.rating_qty }})
                      </span>
                      ·
                      <span class="text-secondary">
                        {{ globalState.cities[professional.province_id] | multiLangName }}
                      </span>
                    </div>
                  </div>
                  <div class="pointer-item" v-if="currentTab !== 'blacklist'">
                    <div v-if="!professional.is_favorited_professional"
                         @click.stop="addFavProfessional(index, professional.id)">
                      <i class="fal fa-heart fa-lg text-pink"></i>
                    </div>
                    <span v-else
                          @click.stop="removeFavProfessional(index, professional.id)">
                      <i class="fas fa-heart fa-lg text-pink"></i>
                    </span>
                  </div>
                </div>
                <div class="d-flex justify-content-start align-items-end">
                  <div class="flex-fill vaccine-section">
                    <professional-vaccination :professional="professional" />
                  </div>
                  <div v-if="currentTab !== 'saved'">
                    <div class="pointer-item">
                      <div v-if="!professional.is_blocked"
                           @click.stop="blockProfessional(index, 1, professional.id)">
                        <i class="fas fa-ban fa-lg text-secondary"></i>
                      </div>
                      <span v-else
                            @click.stop="blockProfessional(index, 0, professional.id)">
                      <i class="fas fa-ban fa-lg text-danger"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.card -->
            </a>
        </div>
      </div>
    </section>
    <div v-else>
      <loader/>
    </div>

    <div class="row text-center mt-3">
      <div class="col-md-12">
        <button
           class="btn btn-outline-info btn-block"
           :disabled="isLoading"
           @click="loadMore()"
           v-if="state.canLoadMore">
          {{ isLoading ? $t('message.button.loading') : $t('message.button.load_more') }}
        </button>
      </div>
    </div>
    <!-- /.row -->
    <instant-booking-modal ref="instantBookingModal"/>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import InstantBookingModal from '../modal/InstantBookingModal'
  import Loader from '../loader/Loader'
  import ProfessionalPicture from './components/ProfessionalPicture'
  import ProfessionalVaccination from './components/ProfessionalVaccination'
  import axios from 'axios'

  export default {
    components: {
      InstantBookingModal,
      Loader,
      ProfessionalPicture,
      ProfessionalVaccination
    },
    data () {
      return {
        currentTab: 'previous',
        queryData: {
          page: 0,
          user_id: null,
          status: this.currentTab
        },
        isLoading: false
      }
    },
    computed: {
      ...mapState('user', ['canLoadMore']),
      ...mapGetters({
        globalState: 'globalVal/getState',
        isLoadMore: 'user/isLoadMore',
        professionals: 'user/getProfessionals',
        state: 'user/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      async loadFirstPage (status) {
        this.currentTab = status
        this.queryData.page = 0
        this.queryData.status = status
        await this.$store.dispatch('user/LOAD_PROFESSIONAL_LIST', this.queryData)
      },
      async loadMore () {
        this.isLoading = true
        this.queryData.page++
        await this.$store.dispatch('user/LOAD_PROFESSIONAL_LIST', this.queryData)
        this.isLoading = false
      },
      blockProfessional (index, isBlocked, professionalId) {
        this.$swal({
          text: (isBlocked) ? this.$i18n.t('message.alert.block_professional') : this.$i18n.t('message.alert.cancel_block_professional'),
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.button.yes'),
          cancelButtonText: this.$i18n.t('message.button.cancel')
        }).then(async (result) => {
          if (result) {
            const url = `/users/${this.user.id}/block-professional`
            const submitData = {
              professional_id: professionalId,
              is_blocked: isBlocked
            }
            const {data} = await axios.post(url, submitData)
            if (!data.error) {
              const updateData = {
                index: index,
                key: 'is_blocked',
                value: isBlocked
              }
              this.$store.commit('user/UPDATE_PROFESSIONAL_DATA', updateData)
              // Remove blocked professional
              if (this.currentTab === 'previous' || this.currentTab === 'blacklist') {
                this.professionals.splice(index, 1)
              }
            }
          }
        })
      },
      async addFavProfessional (index, professionalId) {
        const url = `/users/${this.user.id}/favorites`
        const submitData = {
          professional_id: professionalId
        }
        const {data} = await axios.post(url, submitData)
        if (!data.error) {
          const updateData = {
            index: index,
            key: 'is_favorited_professional',
            value: 1
          }
          this.$store.commit('user/UPDATE_PROFESSIONAL_DATA', updateData)
        }
      },
      async removeFavProfessional (index, professionalId) {
        const url = `/users/${this.user.id}/favorites`
        const submitData = {
          user_id: this.user.id,
          professional_id: professionalId
        }
        const {data} = await axios.delete(url, { data: submitData })
        if (!data.error) {
          if (this.currentTab === 'previous') {
            const updateData = {
              index: index,
              key: 'is_favorited_professional',
              value: 0
            }
            this.$store.commit('user/UPDATE_PROFESSIONAL_DATA', updateData)
          } else if (this.currentTab === 'saved') {
            this.professionals.splice(index, 1)
          }
        }
      },
      openProfessionalDetail (professional) {
        let numServices = 0
        numServices += professional.services.length
        if (professional.experiences) {
          numServices += professional.experiences.length
        }
        if (numServices > 1) {
          this.$parent.openProfessionalServiceModal(professional)
        } else {
          if (professional.services && professional.services.length > 0) {
            this.$router.push('/cleaner/' + professional.id)
          } else if (professional.experiences && professional.experiences.length > 0) {
            this.$router.push('/special-services/' + professional.experiences[0].id)
          }
        }
      }
    },
    watch: {
      professionals () {
        if (this.professionals) {
          const displayedInstantBookingModal = localStorage.getItem('displayedInstantBookingModal')
          if (!displayedInstantBookingModal || displayedInstantBookingModal === 'false') {
            for (let key in this.professionals) {
              const professional = this.professionals[key]
              if (professional.is_favorited_user) {
                this.$refs.instantBookingModal.openModal()
                localStorage.setItem('displayedInstantBookingModal', true)
                break
              }
            }
          }
        }
      }
    },
    created () {
      this.$store.commit('user/SET_CAN_LOAD_MORE', false)
      this.$store.commit('user/SET_NO_DATA')
      this.queryData.user_id = this.user.id
      this.loadFirstPage(this.currentTab)
    }
  }
</script>

<style scoped>
  .vaccine-section {
    font-size: 90%;
  }

  .nav-tabs > a.nav-item , a.active:after {
    display: block;
    padding: 0;
    height: 4px;
    background-color: #00ACC1;
    content: ' ';
    width: 100%;
    margin: 0 auto;
    margin-top: 13px;
  }

  .nav-tabs > a.nav-item {
    background: none;
    border: 0;
    padding: 0;
  }

  .nav-tabs > a.nav-item {
    border-bottom: 1px solid #DDD;
  }

  @media (max-width: 768px) {
    .nav-justified > li {
      display: table-cell;
      width: 1%;
    }

    .nav-justified > li > a {
      border-bottom: 1px solid #DDD;
      border-radius: 0;
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/professional/Index.vue